import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconArrowLeftSquare: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"arrow-left-square"} maskId="square-filled-radius-0-stroke-1-IconArrowLeftSquare"><path fillRule="evenodd" clipRule="evenodd" d="M21 21H3V3H21V21ZM6.79297 12L11 16.207L11.707 15.5L8.70703 12.5H17V11.5H8.70703L11.707 8.5L11 7.79297L6.79297 12Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconArrowLeftSquare;
